import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-linkedin",
  "use": "icon-linkedin-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol role=\"img\" aria-label=\"Description of your SVG image\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-linkedin\">\r\n  <title>linledin</title>\r\n  <path d=\"M14.82,0H1.18A1.17,1.17,0,0,0,0,1.15V14.85A1.17,1.17,0,0,0,1.18,16H14.82A1.17,1.17,0,0,0,16,14.85V1.15A1.17,1.17,0,0,0,14.82,0ZM4.75,13.63H2.37V6H4.75ZM3.56,5A1.38,1.38,0,1,1,3.48,2.2h.07A1.38,1.38,0,0,1,3.56,5Zm10.08,8.68H11.26V9.92c0-.89,0-2-1.23-2s-1.42,1-1.42,2v3.78H6.24V6H8.51V7h0a2.49,2.49,0,0,1,2.25-1.23c2.4,0,2.85,1.58,2.85,3.64Z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./assets/svg/linkedin.svg
// module id = 295
// module chunks = 0 1